import { useEffect } from 'react';

import { APP_NAME } from '../constants';
import { environment } from '../environment/environment';

export const useSetPageTitle = (title: string) => {
  useEffect(() => {
    document.title = `${APP_NAME} - ${title}`;
    if (environment.environment_deploy === 'local') {
      document.title += ' (' + environment.environment_deploy + ')';
    }
  }, [title]);
};
